import formErrorMessages from "@/common/formErrorMessages";

const walletErrors = {
    ...formErrorMessages,
    INVALID_ADDRESS: "wallet_invalid_address",
    WALLET_UNLOCK_FAILED: "wallet_ulock_failed_pwd",
};

export type WalletError = typeof walletErrors;

export default walletErrors;
